/*
    Text defined here & Text defined per appType in customAppTypes.ts, will work as a template for whats expected by Sitecore.
    They will also work as fallback keys IF keys do not exist in Sitecore.
*/
import { StringKeyValue } from '../actions/types';
import CustomAppTypes from './customAppTypes';

const defaultLocalConfigData = {
    text: {
        /* Common */
        productName: 'Kredittkort',
        mainHeader: 'Søk om {productName}',
        mainHeaderGold: 'Søk om {cardNameGold}',
        mainHeaderBusiness: 'Søk om {cardNameBusiness}',
        mainHeaderIncrease: 'Søk om kredittøkning',
        applicationBack: 'Tilbake',
        defaultInfoBoxText:
            'Ta kontakt med Eika Kredittbank på telefon 915 03 850 eller e-post kundesenter@eika.no hvis du har spørsmål. Vi hjelper deg gjerne!',
        return: 'Tilbake',
        next: 'Neste',
        firstPageInfoText1:
            'Du er i ferd med å søke om kredittkort - et betalingskort som kan brukes til kontantuttak eller kjøpe varer og tjenester. Når du bruker kredittkortet låner du penger du må betale tilbake. Du har inntil 45 dager rentefri betalingsutsettelse og en maks grense på innvilget kreditt (kredittgrense).',
        firstPageInfoText2:
            'Velger du å nedbetale det du skylder over tid, vil det påløpe renter. Gjeldende rentesatser, priser og vilkår finner du på våre nettsider. Skulle betingelsene endres, vil du få varsel i god tid før endringene trer i kraft.',

        /* Return URL's */
        returnLinkWeb: '/',
        returnLinkMobile: '/oversikt',
        returnLinkMyCard: '/mitt-kort',

        /* Abort URL's */
        abortUrlWeb: '/fullfor-soknad',
        abortUrlMobile: '/fullfor-soknad',
        abortUrlMyCard: '/fullfor-soknad',

        /* Card Info */
        cardNameGold: 'Gold kredittkort',
        cardNameBusiness: 'Business kredittkort',

        processTitlev2: 'Søk {productName}',
        initialSummaryIntro:
            'Søk lån her og få svar med en gang. Lurer du på noe, eller trenger hjelp med bestillingen, kan du kontakte oss på telefon eller e-post.',
        bankIdButton: 'Fyll ut søknaden',

        /* Loader */
        loadingDefault: 'Laster...',
        loadingNafCheck: 'Utfører medlemssjekk...',
        loadingUser: 'Sjekker kundeforhold...',
        loadingKdk: 'Henter tilleggsinformasjon...',
        loadingCards: 'Henter kortinformasjon...',
        loadingStatus: 'Henter status...',
        loadingAgriMember: 'Henter kundeinfo fra Agrol...',
        loadingCreditCheck: 'Utfører kredittsjekk...',
        loadingSigning: 'Klargjør signering...',
        loadingReceipt: 'Fullfører signering...',
        loadingCase: 'Henter sak...',

        /* Dialog Component */
        dialogGreeting: 'Hei',
        dialogCardIngress: 'Vi ser at du har følgende kredittkort hos oss:',
        dialogMessageCard: 'Når du går videre kan du se hvor høy kredittgrense du kan få. Hva vil du gjøre?',
        dialogMessageCardNaf:
            'Når du går videre i søknaden vil du få svar på hvor stor kredittramme du kan få. Med positivt svar kan du øke kredittbeløpet på et av kortene dine.',
        dialogMessageCardUnsupported:
            'Kortet ditt støttes dessverre ikke i denne løsningen, kontakt oss så hjelper vi deg med å oppdatere det!',
        dialogMessageAllCardsOtherBank:
            'Vi ser at du allerede har kredittkort i en annen lokalbank. Det er mulig å flytte kredittkortet til oss. Ta kontakt med kundesenteret.',
        dialogMessageCardOtherBank:
            'Vi ser at du allerede har kredittkort i en annen lokalbank. Du kan ikke søke om samme kort her. Vi kan tilby deg å søke om et annet kredittkort. Når du går videre kan du se hvor høy kredittgrense du kan få.',
        dialogMessageNoCustomer:
            'Det ser ikke ut som du er kunde i banken. Vennligst start søknaden i en Eika-bank hvor du er kunde.',
        dialogMessagePendingApplication:
            'Vi i Eika Kredittbank ser at du allerede er i gang med en søknad om kredittkort et annet sted. Vennligst fullfør den søknaden først.',
        dialogCardNameGold: '{cardNameGold}',
        dialogCardNameBusiness: '{cardNameBusiness}',
        dialogCardNameNaf: 'NAF Kreditt',
        dialogCardNameVivo: 'Vivo',
        dialogButton: 'Gå videre',
        dialogButtonGold: 'Søk om {cardNameGold}',
        dialogButtonGoldIncrease: 'Øk kreditt på ditt {cardNameGold}',
        dialogButtonBusiness: 'Søk om {cardNameBusiness}',
        dialogButtonBusinessIncrease: 'Øk kreditt på ditt {cardNameBusiness}',
        dialogFooterTitle: 'Eika kundesenter',
        dialogFooterInfo: 'Har du andre spørsmål om kredittkort? Vi hjelper deg gjerne!',
        dialogFooterPhone: '915 03 850',
        dialogFooterEmail: 'kundesenter@eika.no',

        /** New mobile design */
        dialogTitle: 'Økning av kredittgrense',
        dialogCreditLimit: 'Din kredittgrense',
        dialogIncreaseButtonText: 'Øk kredittgrensen',
        dialogApplyBusinessPre: 'Ønsker du et ekstra kort for å skille mellom privat og arbeid kan du søke om',

        /* 1.Contact */
        creditAmountInputLabel: 'Hvilken kredittgrense ønsker du?',
        creditAmountDefaultValue: '50000',
        creditAmountTitle: 'Kredittgrense',
        creditAmountDefaultValueYoung: '25000',

        currentCreditAmountTitle: 'Din kredittgrense er: ',

        accountStatusInvalidTitle: 'Du kan ikke søke på nåværende tidspunkt',
        accountStatusInvalidText: 'Ta kontakt med oss på kredittbehandling@eika.no',

        contactInfoTitle: 'Kontaktinformasjon',
        contactInfoGreeting: 'Hei',
        contactInfoTextGold:
            'Takk for at du søker om {cardNameGold}. Du vil straks få svar på om du får kort og hvor høy kredittgrense du kan få.',
        contactInfoTextGoldEndre:
            'Takk for at du søker om økt kredittgrense på {cardNameGold}. Du vil straks få svar på hvilken kredittgrense du kan få.',
        contactInfoTextBusiness:
            'Takk for at du søker om {cardNameBusiness}. Du vil straks få svar på om du får kort og hvor høy kredittgrense du kan få.',
        contactInfoTextBusinessEndre:
            'Takk for at du søker om økt kredittgrense på {cardNameBusiness}. Du vil straks få svar på hvilken kredittgrense du kan få.',

        /* 2.About */
        aboutTitle: 'Om deg',

        /* 3.KDK */
        kdkTitle: 'Tilleggsopplysninger',
        kdkInfoQuestions: 'Vi lovpålagt å stille deg noen spørsmål som ledd i vår kundekontroll.',
        kdkInfoNoQuestions: 'Du er allerede kunde og har allerede gitt oss de opplysningene vi trenger.',
        kdkCreditCheckTitle: 'Kredittsjekk',
        kdkCreditCheckDescription:
            'Når du søker om kredittkort eller økning av kredittgrense vil vi utføre en kredittsjekk og innhente opplysninger fra kredittopplysningsforetak og gjeldsregister.',
        kdkCreditCheckDescription2:
            'Ved å sende inn søknaden bekrefter jeg at de oppgitte opplysninger om min økonomiske situasjon er korrekte. Jeg er også kjent med at eventuell forfalskning eller tilbakeholdelse av opplysninger eller annen dokumentasjon fra min side kan resultere i at avtalen oppheves.',
        kdkFormError: 'Mangler noen parametere for å kunne fylle ut skjema',
        kdkProcessInvalid: 'Finner ikke skjema for deg å fylle ut',
        kdkSubmitButton: 'Send inn søknad',
        kdkInfoMessage:
            'Alle nye kunder trenger å bekrefte og besvare noen lovpålagte spørsmål før vi kan behandle søknaden ferdig. Vennligst bekreft og besvar spørsmålene nedenfor.',

        /* 4.Summary - Approved */
        summaryTitle: 'Svar på søknad',
        summaryInfoTitle: 'Gratulerer!',
        summaryInfoTextPre: 'Du kan få inntil',
        summaryInfoTextPost:
            'i kredittramme. Det er lurt å ikke velge mer enn du trenger. Vi har derfor satt en anbefalt sum som du justerer etter eget ønske.',
        summarySelectCreditTitle: 'Hvor mye kreditt trenger du?',
        summaryDesiredDueDateTitle: 'Ønsket forfallsdato',
        summaryCreditStartLimit: '50000',
        summarySendBestillingButton: 'Bestill og signer',
        summaryInfoBoxApproved: '{defaultInfoBoxText}',
        summaryInfoBoxIncrease: '{defaultInfoBoxText}',

        /* 4.Summary - Control */
        summaryTitleControl: 'Søknaden din er gått til manuell behandling',
        summaryTextControl1: 'Vi tar kontakt ved behov. Du får svar innen to arbeidsdager.',
        summaryTextControl2: 'Ved positivt svar kan du starte opp søknaden igjen og komme direkte hit.',
        summaryReturnButtonControl: 'Avslutt og gå til kredittkort',
        summaryInfoBoxControl: '{defaultInfoBoxText}',

        /* 4.Summary - Control - Feedback */
        feedbackTitle:
            'Har du informasjon som kan hjelpe oss i å vurdere søknaden din? Gi oss gjerne tilbakemelding her:',
        feedbackLabel: 'Tilbakemelding',
        feedbackPlaceholder: 'Legg inn en tilbakemelding her',
        feedbackButton: 'Oppdater saken',
        feedbackResponse: 'Takk! Saken er nå oppdatert!',

        /* 4.Summary - Denied */
        summaryTitleDeclined: 'Søknaden er avslått',
        summaryTextDeclined1: 'Vi kan dessverre ikke tilby deg kredittkort på nåværende tidspunkt.',
        summaryTextDeclined2:
            'Din økonomiske situasjon kan forandre seg fort og da er du hjertelig velkommen til å søke igjen.',
        summaryReturnButtonDeclined: 'Avslutt',
        summaryInfoBoxDeclined: '{defaultInfoBoxText}',
        summaryInfoBoxDeclinedFrozen:
            'Du har aktivert frivillig kredittsperre hos kredittopplysningsforetak. Da får ikke vi hentet noe informasjon på deg og du kan ikke søke om kredittkort eller lån. Hvis du fjerner sperren hos Dun & Bradstreet så kan du søke på nytt.',

        summarySetPinTitle: 'Egendefinert PIN-kode',
        summarySetPinEnabled: 'true',
        summarySetPinLabel: 'Ønsket PIN-kode',
        summarySetPinLabelConfirm: 'Bekreft PIN-kode',
        summarySetPinCheckboxLabel: 'Jeg ønsker å sette egendefinert PIN-kode',
        summarySetPinTooltip:
            'PIN-koden må være på 4 siffer og kan ikke inneholde 3 eller flere siffer som er like eller i stigende/synkende rekkefølge',
        loanDetailsConsentTooltipText: 'Hva betyr dette?',
        loanDetailsConsentModalButtonText: 'Ok, jeg forstår',
        /* Consent */
        samtykkeHeader: 'Få relevant informasjon og tilbud fra banken',
        samtykkeIntro: 'Ja, jeg samtykker til:',

        /* Expanding Table Row */
        expandTitle: 'Om {productName}',

        expandTermsTitle: 'Vilkår og betingelser',
        expandTermsText1: 'Du får svar umiddelbart. Da kan du gjøre ditt valg og gå til signering.',
        expandTermsText2:
            'Du kan dessverre kun gjøre én ting om gangen. Du må ha Gold kredittkort før du kan søke om Business kredittkort.',
        expandTermsText3:
            'Hvis du avbryter etter å ha fått svar, så kan du starte søknaden på nytt og komme rett til svaret.',
        expandTermsText4: '{cardNameGold}: kr 12 000,- over 1 år, eff. rente 20,98 %, totalt kr 13 258,-.',
        expandTermsText5: '{cardNameBusiness}: kr 12 000,- over 1 år, eff. rente 21,75 %, totalt kr 13 298,-.',
        expandTermsText6: 'Du kan sammenligne våre priser med priser fra andre selskaper på Finansportalen.',
        expandTermsText7: 'Gå til Finansportalen.no',
        expandTermsText7Url: 'https://www.finansportalen.no/bank/kredittkort/',
        expandTermsText8: 'Håper du blir fornøyd med ditt kredittkort!',

        expandPrivacyTitle: 'Personvern',
        expandPrivacyText1:
            'Denne finansieringstjenesten leveres av Eika Kredittbank AS som er ansvarlig for behandling av personopplysningene som oppgis og hentes inn. Vi trenger dine opplysninger for å kunne gi deg riktige betingelser og kunne inngå en avtale med deg.',
        expandPrivacyText2:
            'Vi lagrer opplysningene så lenge det kan oppstå et krav knyttet til finansieringstjenesten. Om du ikke får innvilget eller benytter deg av finansieringstjenesten lagrer vi opplysningene i 3 måneder etter at de er gitt til oss. Når du har fått innvilget en finansieringstjeneste hos oss kan vi bruke opplysningene om hvilke produkter du har for å tilpasse vår kommunikasjon til deg.',
        expandPrivacyText3: 'Spørsmål om personvern?',
        expandPrivacyText4:
            'Dersom du ønsker informasjon om dine rettigheter rundt blant annet sletting, innsyn, klage, og samtykke finner du det på vår personvernside.',
        expandPrivacyText5: 'Gå til personvernsiden',
        expandPrivacyText5Url: 'https://www2.eika.no/personvern-cookies',
        expandPrivacyText6: 'Vårt personvernombud hjelper deg gjerne. Send e-post til personvern.kredittbank@eika.no',

        expandKycTitle: 'Antihvitvaskinformasjon',

        /* Signing */
        signingHeader: 'Signer kundeavtalen',
        signingMobileText:
            'For å kunne signere, må vi åpne siden i nettleseren på mobilen. Du må logge inn på nytt med BankID.',
        signingMobileButton: 'Åpne signering',
        signingInfoBox:
            'Du er i ferd med å inngå en avtale om kredittkort med banken. Les grundig gjennom forbrukerforklaringen, selve kredittkortavtalen og de Standardiserte europeiske opplysninger om forbrukerkreditt (SEF) for å sikre at kredittkortet passer til ditt behov og din økonomi.',
        signingInfoBox2:
            'Husk at BankID-passord og kodebrikke må aldri deles med andre. Har du spørsmål vedrørende signeringen? Vi hjelper deg på telefon 915 03 850 eller e-post kundesenter@eika.no',
        /* Signing Tips */
        signingTipsText: 'Etter signering må du trykke på blå knapp med pil for å bli helt ferdig.',

        /* Signing Receipt */
        receiptHeader: 'Tusen takk!',
        receiptText1: 'Søknaden er ferdig, alt gikk bra og vi takker for at du vil være kunde hos oss.',
        receiptText2: 'Nytt kort vil sendes innen få dager. Ny kredittgrense vil være klar til bruk innen få timer.',
        receiptIncreaseText1: 'Søknaden er ferdig, alt gikk bra og vi takker for at du vil være kunde hos oss.',
        receiptIncreaseText2: 'Ny kredittgrense vil være klar til bruk innen få timer.',
        receiptReturnButton: 'Avslutt',
        receiptInfoBox: '{defaultInfoBoxText}',

        /* Signing Errors */
        signingErrorHeader: 'Vi beklager!',
        signingErrorText1: 'Det har oppstått en feil i løsningen.',
        signingErrorText2: 'Vi jobber med å løse feilen. Håper du prøver igjen litt senere.',
        signingErrorReturnButton: 'Gå til kredittkort',
        signingErrorInfoBox: '{defaultInfoBoxText}',

        /* Generic Error */
        genericErrorHeader: 'Vi beklager',
        genericErrorText1: 'Vi klarte ikke å behandle søknaden akkurat nå.',
        genericErrorText2:
            'Du kan gå tilbake til forrige steg og prøve igjen. Hvis det fortsatt er feil, så må du dessverre vente en stund. Vi er på saken og prøver å løse feilen så fort som mulig.',
        genericErrorText3: '',
        genericErrorReturnButton: 'Gå tilbake til {productName}',
        genericErrorReturnLink: '/betale/kredittkort',
        genericErrorInfoBox: '{defaultInfoBoxText}',

        /* External Service Error */
        serviceErrorHeader: 'Vi beklager',
        serviceErrorText1: 'Vi klarte ikke å kommunisere med ekstern tjeneste.',
        serviceErrorText2:
            'Du kan prøve å laste siden på ny og prøve igjen. Hvis det fortsatt er feil, så må du dessverre vente en stund. Vi er på saken og prøver å løse feilen så fort som mulig.',
        serviceErrorReturnButton: 'Last siden på ny',
        serviceErrorReturnLink: '/',
        serviceErrorInfoBox: '{defaultInfoBoxText}',

        taxYearErrorHeader: 'Vi beklager',
        taxYearErrorText1:
            'Vi fikk ikke tilbake noe data på skatt og inntekt og har dermed ikke nok informasjon til å vurdere søknaden.',
        taxYearErrorText2:
            'Hvis du mener dette er feil og har nok data fra siste skatteår, så ta kontakt med oss. Vi kan da kanskje få overført data fra deg manuelt og behandle saken manuelt.',
        taxYearErrorInfoBox: '{defaultInfoBoxText}',

        /* Kort Error */
        cardErrorHeader: 'Vi beklager',
        cardErrorText1: 'Vi har litt problemer med å hente ut kortinformasjon akkurat nå.',
        cardErrorText2:
            'Du kan gå tilbake til forrige steg og prøve igjen. Hvis det fortsatt er feil, så må du dessverre vente en stund. Vi er på saken og prøver å løse feilen så fort som mulig.',
        cardErrorText3: '',
        cardErrorReturnButton: 'Gå tilbake til {productName}',
        cardErrorReturnLink: '/betale/kredittkort',
        cardErrorInfoBox: '{defaultInfoBoxText}',

        /* New Customer Stop Message */
        newCustomerStopHeader: 'Takk for at du ønsker kredittkort hos oss',
        newCustomerStopText1:
            'Vi tilbyr dessverre ikke søknader på nye kort her nå. Det er kun mulig å endre kredittgrense på kort som allerede finnes.',
        newCustomerStopText2:
            'Kontakt oss hvis du mener noe er feil. Ellers håper vi å kunne tilby dette i fremtiden og ønsker deg tilbake da.',
        newCustomerStopLink: '/',
        newCustomerStopLinkText: 'Avslutt',
        newCustomerStopInfoBox: '{defaultInfoBoxText}',

        /* Not ready */
        ikkeKlarHeader: 'Lånedokumentene er ikke klare til signering',
        ikkeKlarText1:
            'Du må dessverre vente litt. Vennligst sjekk e-posten vi har sendt deg og gå til signering senere.',
        ikkeKlarInfoBox: '{defaultInfoBoxText}',

        /* Not a customer */
        ikkeKundeHeader: 'Beklager, du er ikke kunde i banken!',
        ikkeKundeText1v2: 'Du må være kunde i banken for å kunne søke om {productName}.',
        ikkeKundeText3v2:
            'for å opprette et kundeforhold i banken. Etter ca. fem arbeidsdager kan du søke om {productName} på nytt.',
        ikkeKundeLink: '/bli-kunde#/personal',
        ikkeKundeLinkText: 'Bli kunde',
        ikkeKundeInfoBox: '{defaultInfoBoxText}',

        /* Invalid customer */
        ugyldigKundeHeader: 'Vi beklager, kortet ditt støttes ikke.',
        ugyldigKundeText1v2:
            'Kortet ditt støttes dessverre ikke denne løsningen, kontakt oss så hjelper vi deg gjerne med å oppdatere det!',
        ugyldigKundeLink: '/',
        ugyldigKundeLinkText: 'Tilbake til forsiden',
        ugyldigKundeInfoBox: '{defaultInfoBoxText}',

        /* D-Number Customer */
        dNummerKundeHeader: 'Beklager, du har ugyldig fødselsnummer',
        dNummerKundeText: 'Du kan dessverre ikke søke om {productName} med D-nummer.',
        dNummerKundeLinkText: 'Tilbake til forsiden',
        dNummerKundeLink: '/',
        dNummerKundeInfoBox: '{defaultInfoBoxText}',

        /* Minor Customer */
        mindreaarigKundeHeader: 'Beklager, du er ikke gammel nok',
        mindreaarigKundeText: 'Du kan dessverre ikke søke om {productName} når du er under 18 år.',
        mindreaarigKundeLinkText: 'Tilbake til forsiden',
        mindreaarigKundeLink: '/',
        mindreaarigKundeInfoBox: '{defaultInfoBoxText}',

        /* AAA Soliditet */
        aaaSoliditetErrorHeader: 'Beklager, vi finner ikke ditt fødselsnummer',
        aaaSoliditetErrorText:
            'Vi finner ikke ditt fødselsnummer hos kredittsjekk. Dersom du nylig har fylt 18 år vil dette bli oppdatert snart. Gjerne prøv å bestill {productName} igjen om noen dager.',
        aaaSoliditetErrorLinkText: 'Tilbake til forsiden',
        aaaSoliditetErrorLink: '/',
        aaaSoliditetErrorInfoBox: '{defaultInfoBoxText}',

        /* 404 Page not found */
        pageNotFoundTitle: 'Siden finnes ikke',
        pageNotFoundText1: 'Vi beklager så mye, men vi finner ikke siden du leter etter.',
        pageNotFoundText2: '',
        pageNotFoundText3: 'Vårt beste tips er å bruke menyen, håper at du finner det du leter etter der.',

        /* Agricard unique keys */
        agricardInvalidUserHeader: 'Feil informasjon',
        agricardInvalidUserText1:
            'I informasjonen som ble oversendt fra Agrol var det en eller flere feil. Du kan derfor ikke søke om Agricard akkurat nå.',
        agricardInvalidUserText2:
            'Vennligst gå tilbake til Agrol og prøv på nytt. Hvis det fortsatt ikke fungerer, så må du ta kontakt med Agrol.',
        agricardInvalidUserInfoBox: 'Kontakt Agrol på post@agrol.no eller telefon 22 17 47 74. Lykke til!',

        agricardInvalidTokenHeader: '{agricardInvalidUserHeader}',
        agricardInvalidTokenText1: '{agricardInvalidUserText1}',
        agricardInvalidTokenText2: '{agricardInvalidUserText2}',
        agricardInvalidTokenInfoBox: '{agricardInvalidUserInfoBox}',

        agricardExpiredTokenHeader: 'Tiden er utløpt',
        agricardExpiredTokenText1:
            'Du har dessverre brukt litt for lang tid på å fullføre søknaden og vi har mistet informasjonen vi fikk fra Agrol.',
        agricardExpiredTokenText2:
            'Vennligst gå tilbake til Agrol og gjør det en gang til. Vi beklager og håper det går bra neste gang.',
        agricardExpiredTokenInfoBox: '{defaultInfoBoxText}',

        /* NAF unique keys */
        nafMedlemSjekkInfoTekst:
            'For å søke om NAF Smålån må du være NAF-medlem. Fyll ut feltene nedenfor så sjekker vi mot NAF. Du kan velge mellom mobilnummer og medlemsnummer.',
        nafMedlemSjekkMobilnummer: 'Mobil',
        nafMedlemSjekkMedlemsnummer: 'Medlemsnummer',
        nafMedlemSjekkVerifiseringMobilnummerLabel: 'Mobilnummer (8 tall)',
        nafMedlemSjekkVerifiseringMedlemsnummerLabel: 'Medlemsnummer',
        nafMedlemSjekkFoedselsdatoLabel: 'Fødselsdato (ddmmåååå)',
        nafErrorMobiltelefon: 'Mobilnummer må være 8 siffer',
        nafErrorFoedselsdato: 'Fødselsdato må være 8 siffer',
        nafErrorIkkeGyldigFoedselsdato: 'Angitt verdi er ikke en gyldig fødselsdato',
        nafErrorIkkeGammelNok: 'Du må være minst 18 år for å søke dette lånet',
        nafErrorMedlemsnummer: 'Medlemsnummer kan ikke være tomt.',
        nafErrorIkkeMedlem:
            'Vi fant deg ikke i medlemsregisteret til NAF. Er du sikker på at det du har skrevet inn er riktig og likt det som er registrert hos NAF? Prøv igjen eller ta kontakt med NAF.',
        nafErrorFoedselsdatoMatcherIkkeFnr: 'Fødselsdatoen matcher ikke innlogget bruker sin fødselsdato.',
        nafErrorBadRequest: 'Sjekk at formatet er riktig',

        lbsBankSelectMultipleRelations:
            'Du har kundeforhold i flere banker hos oss. Velg banken ditt kredittkort er knyttet til',
        lbsBankSelectTitle: 'Hvor er du bankkunde?',
        lbsBankSelectDropdownLabel: 'Hvilken bank er du kunde i?',
        lbsBankSelectInfoTekst:
            'Lokalbank Selskapet består av 10 banker som tilbyr Smålån til sine kunder her. Du må velge hvilken bank du er kunde i.',
        lbsBankSelectButtonText: 'Til søknaden',
        lbsAvailableBanks: '1100;1885;2630;2635;4285;4290;4336;4358;4484;4730',
        lbsNoBanksTitle: 'Ingen tilgjengelige banker',
        lbsNoBanksText: 'Vi fant ingen tilgjengelige lokalbanker for øyeblikket. Vennligst prøv igjen senere.',

        /* Form Errors */
        errorCheckForm: 'Vennligst kontroller skjemaet',
        errorEmail: 'Ikke gyldig e-postadresse',
        errorEmptyCreditAmount: 'Du må fylle inn ønsket kredittbeløp',
        errorEmptyEmail: 'Du må fylle inn din e-postadresse',
        errorMobiltelefon: 'Mobilnummer må være 8 siffer',
        errorEmptyMobilnummer: 'Du må fylle inn ditt mobilnummer',
        errorEmptySikretGjeld: 'Du må fylle inn din totale sikrede gjeld',
        errorEmptyHarAndreKort: 'Du må svare på om du har kredittkort i andre banker',
        errorEmptyVerv:
            'Du må fylle inn vervet eller stillingen for den politisk eksponerte personen (deg eller noen andre)',
        errorEmptyFodeland: 'Du må velge fødeland',
        errorEmptyStatsborgerskap: 'Du må velge statsborgerskap',
        errorEmptySekundaertStatsborgerskap: 'Du må velge sekundært statsborgerskap',
        errorEmptyPep: 'Du må velge inn pep',
        errorEmptyRelasjon:
            'Du må fylle inn relasjonen du har til den politisk eksponerte personen (deg eller noen andre)',
        errorInvalidCredit: 'Du må velge et gyldig beløp, sjekk at brukt kreditt ikke overstiger ønsket kredittgrense.',
        errorInvalidPin: 'Ugyldig PIN-kode. Sjekk retningslinjene for PIN ovenfor',
        errorInvalidPinConfirm: 'PIN-koden må være den samme som i forrige steg',

        formEmailLabel: 'E-post',
        formPhoneLabel: 'Mobil',
        formMaritalStatusLabel: 'Sivilstatus',
        formLivingConditionsLabel: 'Boforhold',
        formWorkingConditionsLabel: 'Arbeidsforhold',
        formSecuredDebtLabel: 'Din andel av gjeld/lån til bolig, bil, andre objekter og studielån',
        formSecuredDebtSubLabel:
            'Fyll inn totalsummen av all sikret gjeld/lån du har. Hvis du har medlåntaker, så bruker du bare din andel av lånene.',
        formHasOtherCardsLabel: 'Har du kredittkort i andre banker fra før?',

        schemaFieldMaritalStatusArray: '1:Ugift;2:Samboer;3:Gift;4:Separert/skilt;5:Enke/enkemann',
        schemaFieldChildrenArray: '1:0;2:1;3:2;4:3+',
        schemaFieldHousingArray: '1:Eier bolig;2:Leier bolig;3:Bor hos foreldre',
        schemaFieldEmploymentArray:
            '1:Fast ansatt;2:Midlertidig/vikar;3:Student;4:Pensjonist;5:Arbeidsledig;6:Arbeidsavklaringspenger;7:Ufør;8:Lærling',
        currencyInputPlaceholder: 'Fyll inn antall kr',

        /* SBL */
        sblTitle: 'Vi trenger ditt samtykke',
        sblInfoText1:
            'Vi henter lønnsslipper for siste halvår og siste skattemelding fra Skatteetaten digitalt. Du slipper å finne frem dokumentasjon og sende det som vedlegg til søknaden - enklere for både deg og oss. For at vi skal kunne gjøre det må du samtykke til at vi kan hente disse opplysningene.',
        sblInfoText2:
            'Når du trykker på "Gi samtykke" under vil du bli sendt til altinn.no for å logge deg inn og samtykke. Samtykket blir gitt til Eika Kredittbank AS. Du kommer deretter tilbake hit og kan fortsette søknaden.',
        sblGoToAltinnButtonText: 'Gi samtykke',
        sblErrorHeader: 'Noe gikk galt med Altinn',
        sblErrorText: 'Vi kan ikke gå videre fordi samtykket med Altinn ble avslått eller det skjedde en intern feil.',
        sblErrorLinkText: 'Tilbake til forsiden',
        sblErrorLink: '/',
        sblErrorInfoBox: '{defaultInfoBoxText}',

        /* Traffic Light */
        trafficLightPre: 'Din betalingsevne er vurdert til',
        trafficLightGreen: 'grønn',
        trafficLightYellow: 'gul',
        trafficLightRed: 'rød',
        trafficLightModalTitle: 'Din betalingsevne',
        trafficLightModalP1:
            'Vi er pålagt å kartlegge din fremtidige betalingsevne for å forutse hvordan du vil kunne håndtere din gjeld dersom betingelsene for kreditten endrer seg.',
        trafficLightModalP2Green:
            'Vi vurderer din betalingsevne som god. Du antas å kunne håndtere en potensiell økning av renten tilknyttet din kreditt godt.',
        trafficLightModalP2Yellow:
            'Vi vurderer din betalingsevne som middels god. Du antas å kunne håndtere en potensiell økning av renten tilknyttet din kreditt med moderate tilpasninger i din økonomi.',
        trafficLightModalP2Red:
            'Vi vurderer din betalingsevne som lav. Du antas å ikke være i stand til å håndtere en potensiell økning av renten tilknyttet din kreditt med mindre du gjør større tilpasninger i din økonomi.',
        trafficLightModalClose: 'Lukk',
    },
};

interface Config {
    text: StringKeyValue;
}

const transformLocalConfigData = (appType: string) => {
    const transformedText: StringKeyValue = { ...defaultLocalConfigData.text };

    const appTypeSpecificConfig: Config = CustomAppTypes.resolveConfig(appType);

    Object.keys(appTypeSpecificConfig.text).forEach((key) => {
        transformedText[key] = appTypeSpecificConfig.text[key];
    });

    return { ...defaultLocalConfigData, text: transformedText };
};

const resolveLocalConfigData = (appType: string, defaultAppType: string): Config => {
    return appType === defaultAppType ? defaultLocalConfigData : transformLocalConfigData(appType);
};

export default resolveLocalConfigData;
